<template>
  <div class="">
    <sidebar-menu
      :menu="menu"
      width="16vw"
      :collapsed="collapsed"
      :hideToggle="true"
      :theme="selectedTheme"
      :show-one-child="true"
      @item-click="onItemClick">

      <template slot="header">
        <div class="row  pl-2 pt-2 headerElementStyle">
          <div class="col-9">
            <h1 class="text-white">{{sideBarTitle}}</h1>
          </div>
          <div class="col-3">
            <!-- <base-button
              size="sm"
              type="light"
              class="btn-customgray"
              icon="ni ni-curved-next"
              v-on:click="openModalClicked"
            >
            </base-button> -->
          </div>
        </div>

      </template>
    </sidebar-menu>
  </div>

</template>
<script>
import modal from "@/components/Modal";
  export default {
    name: "DashboardNavbar",
    components: {
      modal
    },
    props: {
      menu: Array,
      sideBarTitle: String
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        collapsed: false,
        // selectedTheme: 'white-theme',
        selectedTheme: '',
        openModal: false,
        selectedLine: "0",
        selectedPortfolio: "",
        currentSelectedProject: "",
        currentSelectedSubCategory: ""
      };
    },
    computed: {
      currentSelectedCategory: {
        get() {
          return this.$store.state.sideBarStore.currentSelectedCategory
        }
      }
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      onItemClick(event, item) {
        const current = this
        event.preventDefault();
        var categories =  [];
        var subCategories =  [];
        current.$store.state.sideBarStore.categories.forEach((categoryItem, categoryIndex) => {
          categories.push(categoryItem.title)
          // current.$store.state.sideBarStore.subCategories[categoryItem.code].forEach((subCategoryItem, subCategoryIndex) => {
          //   subCategories.push(subCategoryItem.title)
          // });
        });

        var categorySelected = current.$store.state.sideBarStore.currentSelectedCategory

        if(categories.includes(item.title)){
          current.$store.state.sideBarStore.categories.forEach((categoryItem, categoryIndex) => {
            if(item.title == categoryItem.title){
              categorySelected = categoryItem
              current.$store.commit("sideBarStore/setCurrentSelectedCategory",categoryItem)
              // var currentCategoryTab = current.$store.state.sideBarStore.subCategories[categorySelected.code].filter(obj=>obj.title == "Overview")[0];
              current.$store.commit("sideBarStore/setCurrentSelectedTab", categoryItem)

              console.log(categoryItem.tabs[0].code+"Section");
              console.log(document.getElementsByClassName("tabList")[0].getElementsByTagName('a').item(0).innerText);
              var tabList = document.getElementsByClassName("tabList")[0].getElementsByTagName('a')
              tabList.item(0).click()
              current.$store.commit("sideBarStore/setActiveTabFlags", categoryItem.tabs[0].code+"Section")
              // categoryItem.tabs.forEach((item, index) => {
              //   if(current.$store.state.sideBarStore.activeTabFlags[item.code+"Section"] == true){
              //     console.log("hey test");
              //     //current.$store.commit("sideBarStore/setActiveTabFlags", item.code+"Section")\
              //     //current.$store.commit("sideBarStore/setActiveTabFlags", categoryItem.tabs[0].code+"Section")
              //     console.log("hello",item.code+"Section")
              //   }else{
              //     console.log("hello test")
              //   }
              // });

              // if(categoryItem.title == "Zone Overview"){
              //   current.$store.commit("sideBarStore/setActiveTabFlags", "gisSection")
              // }
              // else {
              //   current.$store.commit("sideBarStore/setActiveTabFlags", "inventorySection")
              // }

              // current.$store.commit("sideBarStore/setCurrentSelectedSubCategory", "Overview")
              // var currentSubCategoryTab = current.$store.state.sideBarStore.subCategories[categorySelected.code].filter(obj=>obj.title == "Overview")[0];
              // current.$store.commit("sideBarStore/setCurrentSelectedTab", currentSubCategoryTab)
              // current.$store.commit("sideBarStore/setActiveTabFlags", "overviewSection")
              // current.$store.commit("sideBarStore/setCurrentSelectedSubCategory", "Overview")
            }
          })

        }
        else {
          if(subCategories.includes(item.title)){
            current.$store.commit("sideBarStore/setCurrentSelectedSubCategory",item.title)
            var currentSubCategoryCode = current.$store.state.sideBarStore.subCategories[categorySelected.code].filter(obj=>obj.title == item.title)[0];
            current.$store.commit("sideBarStore/setCurrentSelectedTab",currentSubCategoryCode)
          }

        }
      },
      openModalClicked: function() {
        this.openModal = true;
      },
      closeModalClicked: function() {
        this.openModal = false;
      },
    },
  };
</script>
<style>
.main-content {
    position: fixed !important;
    margin-left: 0px !important;
    width: 94.5%;
    width: -moz-available;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
    width: fill-available
}
.v-sidebar-menu {
    position: fixed !important;
    top: inherit !important;
    left: inherit !important;
    height: 100% !important;
}
.text-active-color span{
  color: #E66200 !important;
  font-weight: bold!important;
  font-size: 20px;
  /* border: 1px solid #fff !important; */
}
</style>
